import React from "react";
import Svg, { Path } from "react-native-svg";

const BackArrow = (props) => {
  const { height = 24, width = 24 } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Path
        d="M19.918 11.272a1.329 1.329 0 00-.223-.016H6.997l.277-.125c.27-.124.516-.294.727-.5l3.561-3.46a1.268 1.268 0 00.187-1.659 1.312 1.312 0 00-1.932-.162l-6.44 6.257a1.227 1.227 0 000 1.77l6.44 6.258a1.315 1.315 0 001.932-.125 1.268 1.268 0 00-.187-1.659l-3.554-3.466a2.575 2.575 0 00-.644-.457l-.387-.169h12.648c.657.024 1.235-.423 1.358-1.051.114-.682-.363-1.325-1.065-1.436z"
        fill={props.color ? props.color : "#000"}
        fillOpacity={0.86}
      />
    </Svg>
  );
};

export default BackArrow;
